module.exports = __webpack_public_path__ + "media/img/logos/2023/environment_day-2f40ca37f9c55b05bb1972eefe62ab58.svg";